export const gstcData: any = {
  // "Hotels" : {
  "Hotels - Section A: Demonstrate effective sustainable management": {
    "A1 Sustainability management system": {
      comments: "",
      attachments: [],
      "a. The Sustainability Management System is clearly documented": [
        "text",
        "",
      ],
      "b. The SM System covers environmental, social, cultural, economic, quality, human rights, health and safety issues":
        ["text", ""],
      "c. The SM System includes consideration of risk and crisis management": [
        "text",
        "",
      ],
      "d. Documentary evidence shows implementation of the SM system": [
        "text",
        "",
      ],
      "e. The SM System includes a process for monitoring continuous improvement in sustainability performance":
        ["text", ""],
    },
    "A2 Legal compliance": {
      comments: "",
      attachments: [],
      "a. An up to date list of all applicable legal requirements is maintained":
        ["text", ""],
      "b. Certificates or other documentary evidence show compliance with all applicable legal requirements":
        ["text", ""],
    },
    "A3 Reporting and communication": {
      comments: "",
      attachments: [],
      "a. Regular reports are made available on sustainability performance": [
        "text",
        "",
      ],
      "b. Sustainability policies and actions are reported in external and internal communication material":
        ["text", ""],
      "c. Communications contain messages inviting consumer and stakeholder support":
        ["text", ""],
    },
    "A4 Staff engagement": {
      comments: "",
      attachments: [],
      "a. Evidence is available of staff involvement with the SM System": [
        "text",
        "",
      ],
      "b. Records of courses and on-the-job training, with attendance levels, are available":
        ["text", ""],
      "c. Staff training and guidance materials are available in accessible format (including use of minority languages where needed)":
        ["text", ""],
      "d. Staff hold certificates and qualifications in relevant disciplines/skills":
        ["text", ""],
    },
    "A5 Customer experience": {
      comments: "",
      attachments: [],
      "a. A customer feedback system is in place, together with analysis of the results":
        ["text", ""],
      "b. Negative feedback and responses made to this are recorded": [
        "text",
        "",
      ],
      "c. There is evidence of corrective actions taken": ["text", ""],
    },
    "A6 Accurate promotion": {
      comments: "",
      attachments: [],
      "a. Images used in promotion are of actual experiences offered and facilities provided":
        ["text", ""],
      "b. Sustainability claims are based on records of past performance": [
        "text",
        "",
      ],
    },
    "A7 Buildings and infrastructure": {
      "A7.1 Compliance": {
        comments: "",
        attachments: [],
        "a. Awareness of, and compliance with, laws relating to land use and activities in the local area is demonstrated":
          ["text", ""],
        "b. All required licences and permits are up to date": ["text", ""],
        "c. Awareness of, and compliance with, non-statutory area management plans and guidance (e.g. for particular zones, design, etc.), is demonstrated":
          ["text", ""],
      },
      "A7.2 Impact and integrity": {
        comments: "",
        attachments: [],
        "a. Site selection, design and access have takenaccount of visual amenity, landscape, cultural and natural heritage":
          ["text", ""],
        "b. Site selection, design and access have taken account of the protection of biologically sensitive areas and the assimilative capacity of ecosystems":
          ["text", ""],
        "c. The integrity of archaeological, cultural heritage, and sacred sites has been preserved":
          ["text", ""],
        "d. The integrity and connectivity of natural sites and protected areas has been preserved":
          ["text", ""],
        "e. Threatened or protected species have not been displaced and impact on all wildlife habitats has been minimized and mitigated":
          ["text", ""],
        "f. Water courses/catchments/wetlands have not been altered and run-off is reduced where possible and any residue is captured or channeled and filtered":
          ["text", ""],
        "g. Risk factors (including climate change, natural phenomena, and visitor safety) have been assessed and addressed":
          ["text", ""],
        "h. Impact assessment (including cumulative impacts) has beenundertaken and documented as appropriate":
          ["text", ""],
      },
      "A7.3 Sustainable practices and materials": {
        comments: "",
        attachments: [],
        "a. Local materials, practices and crafts have been used in buildings and design where practicable and appropriate":
          ["text", ""],
        "b. Native and endemic plants obtained from sustainable sources have been used in landscaping and decoration, avoiding exotic and invasive species":
          ["text", ""],
        "c. Plants have been selected for their ability to tolerate prevailing or anticipated conditions eg drought tolerant plants":
          ["text", ""],
        "d. Sustainable design, materials and construction practices have been used in buildings, with appropriate certification where possible":
          ["text", ""],
        "e. Waste from construction is sorted and disposed of in an environmentally sound manner":
          ["text", ""],
      },
      "A7.4 Access for all": {
        comments: "",
        attachments: [],
        "a. Sites,  buildings  and  activities  are  accessible  topersons  with   physical  disabilities  and  otherspecial  needs,  as  appropriate to the nature of the operation":
          ["text", ""],
        "b. Clear and accurate information is provided onthe level of accessibility":
          ["text", ""],
        "c. Accessibility is certified or checked with relevant experts/user bodies":
          ["text", ""],
      },
    },
    "A8 Land, water, and property rights": {
      comments: "",
      attachments: [],
      "a. Land ownership and tenure rights are documented": ["text", ""],
      "b. User and access rights for key resources, including land and water, are documented where applicable":
        ["text", ""],
      "c. There is documentary evidence of communication, consultation and engagement with local and indigenous communities":
        ["text", ""],
      "d. Evidence of free, prior and informed consent of local communities is documented, where relevant (showing noinvoluntary resettlement or land acquisition)":
        ["text", ""],
    },
    "A9 Information and interpretation": {
      comments: "",
      attachments: [],
      "a. Information/interpretation  material  about  the natural and cultural heritage of the local area is available and provided to customers":
        ["text", ""],
      "b. Staff are informed and trained about the natural and cultural heritage of the local area":
        ["text", ""],
      "c. Information is provided to customers about appropriate behaviour in the local area":
        ["text", ""],
    },
    "A10 Destination engagement": {
      comments: "",
      attachments: [],
      "a. The organization is involved with sustainable tourism planning and management in the destination, where such opportunities exist":
        ["text", ""],
      "b. The organization participates in partnerships between local communities, NGOs and other local bodies where these exist":
        ["text", ""],
      "c. The organization participates in planning and management meetings and activities concerning sustainable tourism in the destination":
        ["text", ""],
    },
  },
  "Hotels - Section B: Maximize social and economic benefits to the local community and minimize negative impacts":
    {
      "B1 Community support": {
        comments: "",
        attachments: [],
        "a. The organization engages with the local community in identifying needs and opportunities for support and evaluating their potential benefit/impact":
          ["text", ""],
        "b. The level and nature of contributions made to schemes in the local community is recorded":
          ["text", ""],
        "c. The local community is offered the opportunity to access the tourist facilities and services provided":
          ["text", ""],
      },
      "B2 Local employment": {
        comments: "",
        attachments: [],
        "a. The proportion of total employment from persons already residing in the local community is measured and managed":
          ["text", ""],
        "b. The proportion of employment in management positions from persons already residing in the local community is measured and managed":
          ["text", ""],
        "c. Training is offered to local residents to enhance their employment opportunities":
          ["text", ""],
      },
      "B3 Local purchasing": {
        comments: "",
        attachments: [],
        "a. The organization regularly audits its sources of supply of goods and services":
          ["text", ""],
        "b. The proportion of goods and services purchased from locally owned and operated suppliers is measured and managed":
          ["text", ""],
        "c. The proportion of non-locally owned or operated suppliersthat are fair trade is measured and managed":
          ["text", ""],
      },
      "B4 Local entrepreneurs": {
        comments: "",
        attachments: [],
        "a. Locally owned businesses are given access to premises and customers for commercial activity":
          ["text", ""],
        "b. Where appropriate, the organization provides advice and support to local service providers with whom it engages, on the quality and sustainability of their service":
          ["text", ""],
        "c. Opportunities for joint ventures and partnerships with local entrepreneurs are considered and pursued where appropriate":
          ["text", ""],
      },
      "B5 Exploitation and harassment": {
        comments: "",
        attachments: [],
        "a. The organization has a documented policy against exploitation and harassment of vulnerable groups":
          ["text", ""],
        "b. Action is taken to communicate and implement the policy": [
          "text",
          "",
        ],
        "c. The organization engages with the local community in working against exploitation and harassment":
          ["text", ""],
        "d. Records of employee ages are kept and show absence of any form of child labour (as defined by ILO)":
          ["text", ""],
        "e. The organization supports action against child sex tourism": [
          "text",
          "",
        ],
      },
      "B6 Equal opportunity": {
        comments: "",
        attachments: [],
        "a. The organization has identified groups at risk of discrimination, including women and local minorities":
          ["text", ""],
        "b. The proportion of employees drawn from each of these groups is monitored and is commensurate with local demographics":
          ["text", ""],
        "c. Internal promotion includes members of these groups": ["text", ""],
      },
      "B7 Decent work": {
        comments: "",
        attachments: [],
        "a. The organization demonstrates awareness of, and compliance with, international labour standards and regulations":
          ["text", ""],
        "b. Wage levels are monitored and regularly reviewed against national norms for a living wage":
          ["text", ""],
        "c. Training records are kept for all staff, showing the level and frequency of training received":
          ["text", ""],
        "d. Employee contracts show support for health care and social security":
          ["text", ""],
        "e. Water, sanitation and hygiene facilities are provided for all onsite workers":
          ["text", ""],
        "f. Employee satisfaction is monitored": ["text", ""],
        "g. An employee grievance mechanism is in place": ["text", ""],
      },
      "B8 Community services": {
        comments: "",
        attachments: [],
        "a. The organization monitors its impact on the availability of local services":
          ["text", ""],
        "b. A communication/feedback/grievance mechanism is in place for local communities":
          ["text", ""],
        "c. Any reduction in availability of basic services to local communities, identified as the result of the organization’s activities, is addressed":
          ["text", ""],
      },
      "B9 Local livelihoods": {
        comments: "",
        attachments: [],
        "a. Local access to livelihoods is considered in decisions about development and operations":
          ["text", ""],
        "b. A communication mechanism is in place for local communities to report any instance of reduced access to local livelihoods":
          ["text", ""],
      },
    },
  "Hotels - Section C: Maximize benefits to cultural heritage and minimize negative impacts":
    {
      "C1 Cultural interactions": {
        comments: "",
        attachments: [],
        "a. The organization demonstrates awareness of, and compliance with, existing international, national and local good practice and guidance for tourist visits to cultural sitesand indigenous communities":
          ["text", ""],
        "b. The organization engages with communities/sites in reviewing guidance and creating and agreeing additional guidelines as necessary":
          ["text", ""],
        "c. Guidelines are effectively used and communicated": ["text", ""],
        "d. Particular measures are in place to avoid inappropriate interaction with children":
          ["text", ""],
      },
      "C2 Protecting cultural heritage": {
        comments: "",
        attachments: [],
        "a. The organization makes and records monetary contributions to the protection of cultural heritage":
          ["text", ""],
        "b. The organization provides in-kind or other support for cultural heritage":
          ["text", ""],
        "c. Provision is made for local access to sites": ["text", ""],
      },
      "C3 Presenting culture and heritage": {
        comments: "",
        attachments: [],
        "a. Local art/craft is reflected in design and furnishings": [
          "text",
          "",
        ],
        "b. Living cultural heritage and traditions are evident in cuisine, retail, events and other services offered":
          ["text", ""],
        "c. Copyright and intellectual property rights have been observed and necessary permissions obtained":
          ["text", ""],
        "d. The views of the local community have been sought on the presentation of local cultural heritage":
          ["text", ""],
      },
      "C4 Artefacts": {
        comments: "",
        attachments: [],
        "a. Any use of artefacts is transparent and/or documented and reported":
          ["text", ""],
        "b. Where artefacts are used, laws and bylaws have been identified that permit such use":
          ["text", ""],
        "c. Visitors are prevented from removing or damaging artefacts": [
          "text",
          "",
        ],
      },
    },
  "Hotels - Section D: Maximize benefits to the environment and minimize negative impacts":
    {
      "D1 Conserving resources": {
        "D1.1 Environmentally preferable purchasing": {
          comments: "",
          attachments: [],
          "a. A documented environmental purchasing policy is in place": [
            "text",
            "",
          ],
          "b. Preference is given to products and suppliers with environmental certification – notably with respect to wood, paper, fish, other foods, and products from the wild":
            ["text", ""],
          "c. Where certified products and suppliers are not available, consideration is given to origin and methods of growing or production":
            ["text", ""],
          "d. Threatened species are not used or sold": ["text", ""],
        },
        "D1.2 Efficient purchasing": {
          comments: "",
          attachments: [],
          "a. Purchasing favours reusable, returnable and recycled goods": [
            "text",
            "",
          ],
          "b. Purchasing and use of consumable and disposable goods are monitored and managed":
            ["text", ""],
          "c. Unnecessary packaging (especially from food) is avoided, with buying in bulk as appropriate":
            ["text", ""],
        },
        "D1.3 Energy conservation": {
          comments: "",
          attachments: [],
          "a. Total energy used is monitored and managed": ["text", ""],
          "b. Energy used per tourist/night for each type of energy is monitored and managed":
            ["text", ""],
          "c. Renewable sources are favoured and the share of renewable energy in total energy supply is monitored and managed":
            ["text", ""],
          "d. Equipment and practices are used that minimize energy use": [
            "text",
            "",
          ],
          "e. Goals for reducing energy consumption are in place": ["text", ""],
          "f. Staff and guests are given guidance on minimizing energyuse": [
            "text",
            "",
          ],
        },
        "D1.4 Water conservation": {
          comments: "",
          attachments: [],
          "a. Water risk has been assessed and documented": ["text", ""],
          "b. Where water risk has been assessed as high, water stewardship goals have been determined":
            ["text", ""],
          "c. Water used per tourist/night per source is monitored and managed":
            ["text", ""],
          "d. Equipment and practices are used that minimize water consumption":
            ["text", ""],
          "e. Water originates from a legal and sustainable source which has not previously affected, and is unlikely in future to affect, environmental flows":
            ["text", ""],
          "f. Consideration is given to cumulative impacts of tourist in the locality on water sources":
            ["text", ""],
          "g. Goals for reducing water consumption are in place": ["text", ""],
          "h. Staff and guests are given guidance on minimizing water use": [
            "text",
            "",
          ],
        },
      },
      "D2 Reducing pollution": {
        "D2.1 Greenhouse gas emissions": {
          comments: "",
          attachments: [],
          "a. Total direct and indirect greenhouse gas emissions are monitored and managed":
            ["text", ""],
          "b. Carbon Footprint per tourist/night is monitored and managed": [
            "text",
            "",
          ],
          "c. Actions are taken to avoid and reduce significant annual emissions from all sources controlled by the organization":
            ["text", ""],
          "d. Carbon offset mechanisms are used where practical": ["text", ""],
        },
        "D2.2 Transport": {
          comments: "",
          attachments: [],
          "a. Information is provided and promoted to customers on alternative (climate friendly) transport options, for arrival, departure and during their visit":
            ["text", ""],
          "b. Alternative transport options (e.g. bike rental, car sharing, pick-ups) for guests and staff are provided or facilitated":
            ["text", ""],
          "c. Markets accessible by short and more sustainable transport options are favoured.":
            ["text", ""],
          "d. Local suppliers are favoured and daily operations seek to minimize transport use.":
            ["text", ""],
          "e. Transport is monitored and managed": ["text", ""],
        },
        "D2.3 Wastewater": {
          comments: "",
          attachments: [],
          "a. Wastewater is disposed of to a municipal or government approved treatment system, if available":
            ["text", ""],
          "b. If suitable municipal wastewater treatment is not available,there is a system in place on site to treat wastewater (that meets international wastewater quality requirements) and ensures no adverse effects on the local population and the environment":
            ["text", ""],
        },
        "D2.4 Solid waste": {
          comments: "",
          attachments: [],
          "a. The amount of solid waste disposed per tourist/night is monitored and managed":
            ["text", ""],
          "b. A solid waste management plan is in place": ["text", ""],
          "c. The solid waste management plan includes actions to reduce, separate and reuse or recycle food waste":
            ["text", ""],
          "d. Waste disposal is to a government run or approved facility and there is evidence that the facility has no negative impact on the environment or local population":
            ["text", ""],
          "e. Solid waste disposed is measured by type and goals are inplace to minimize non-diverted solid waste":
            ["text", ""],
        },
        "D2.5 Harmful Substances": {
          comments: "",
          attachments: [],
          "a. An inventory of hazardous waste has been made and material safety data sheets (MSDS) are held":
            ["text", ""],
          "b. Action has been taken to source more environmentally friendly alternatives":
            ["text", ""],
          "c. Chemicals, especially those in bulk amounts, are stored and handled in accordance with appropriate standards":
            ["text", ""],
          "d. Visitors are informed about personal use of substances which may be considered harmful to the local environment (such as toxic sunscreens and repellants)":
            ["text", ""],
        },
        "D2.6 Minimize pollution": {
          comments: "",
          attachments: [],
          "a. The potential sources of pollution covered in the criterion have been reviewed and identified":
            ["text", ""],
          "b. The potential sources of pollution covered in the criterion are monitored":
            ["text", ""],
          "c. Action is taken to minimize and where possible eliminate pollution from the sources covered in the criterion":
            ["text", ""],
        },
      },
      "D3 Conserving biodiversity, ecosystems and landscapes": {
        "D3.1 Biodiversity conservation": {
          comments: "",
          attachments: [],
          "a. The organization demonstrates awareness of natural protected areas and areas of high biodiversity value":
            ["text", ""],
          "b. The organization provides and records monetary support for biodiversity conservation in the local area":
            ["text", ""],
          "c. The organization provides and records in-kind or other support for biodiversity conservation in the local area":
            ["text", ""],
          "d. The property is actively managed to support biodiversity conservation":
            ["text", ""],
          "e. The organization is aware of, and mitigates, activity with potential to disturb wildlife and habitats":
            ["text", ""],
          "f. Compensation is made where any disturbance has occurred": [
            "text",
            "",
          ],
          "g. Action is taken to encourage visitors to support biodiversity conservation":
            ["text", ""],
          "h. The organization engages with local conservation NGOs": [
            "text",
            "",
          ],
        },
        "D3.2 Invasive species": {
          comments: "",
          attachments: [],
          "a. Sites are monitored for presence of any invasive species": [
            "text",
            "",
          ],
          "b. Action is taken to ensure invasive species are not introduced or spread":
            ["text", ""],
          "c. A programme is in place to eradicate and control invasive species":
            ["text", ""],
          "d. Landscaping of sites is reviewed to consider use of native species":
            ["text", ""],
        },
        "D3.3 Visits to natural sites": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, existing guidelines for tourist visits to natural sites":
            ["text", ""],
          "b. Guidelines are used when conducting visits and informing guests":
            ["text", ""],
          "c. The organization engages with local conservation bodies to establish/identify issues concerning visits to particular sites":
            ["text", ""],
        },
        "D3.4 Wildlife interactions": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, existing local, national and international regulations and guidelines concerning wildlife interactions, including wildlife viewing":
            ["text", ""],
          "b. The organization engages with the development and implementation of local codes and guidelines for wildlife interactions, including wildlife viewing, as required, based on advice of wildlife experts":
            ["text", ""],
          "c. Direct interactions, in particular feeding, should not be permitted, unless specifically sanctioned by internationally accepted standards or, where standards are not   available, guided by independent wildlife expert advice":
            ["text", ""],
          "d. Measures are taken to minimize disturbance to wildlife": [
            "text",
            "",
          ],
          "e. Impacts on wildlife wellbeing are regularly monitored and addressed":
            ["text", ""],
        },
        "D3.5 Animal welfare": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, relevant laws and regulations concerning captive wildlife":
            ["text", ""],
          "b. Existing guidelines for specific tourist activities involving captive wildlife are implemented":
            ["text", ""],
          "c. Personnel responsible for captive wildlife have appropriate qualifications and experience and are fully licensed":
            ["text", ""],
          "d. The organization is aware of, and complies with, relevant laws and regulations concerning animal welfare":
            ["text", ""],
          "e. There is regular inspection of conditions of captive wildlife and their housing":
            ["text", ""],
          "f. There is regular inspection of conditions of domestic animals": [
            "text",
            "",
          ],
          "g. The organization is aware of, and complies with, relevant laws and regulations concerning captive wildlife":
            ["text", ""],
          "h. Existing guidelines for specific tourism activities involving captive wildlife are implemented":
            ["text", ""],
          "i. Personnel responsible for captive wildlife have appropriate qualifications and experience and are fully licensed":
            ["text", ""],
          "j. The organization is aware of, and complies with, relevant laws and regulations concerning animal welfare":
            ["text", ""],
          "k. There is regular inspection of conditions of captive wildlife and their housing":
            ["text", ""],
          "l. There is regular inspection of conditions of domestic animals and their housing and handling":
            ["text", ""],
        },
        "D3.6 Wildlife harvesting and trade": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, relevant laws and regulations concerning wildlife harvesting and trade":
            ["text", ""],
          "b. Visitors are informed of regulations concerning wildlife harvesting, consumption and trade and of the need to avoid buying illegal products/souvenirs derived from threatened species of wildlife notified by IUCN or CITES":
            ["text", ""],
        },
      },
    },
  "Tour Operators - Section A: Demonstrate effective sustainable management": {
    "A1 Sustainability management system": {
      comments: "",
      attachments: [],
      "a. The Sustainability Management System is clearly documented": [
        "text",
        "",
      ],
      "b. The SM System covers environmental, social, cultural, economic, quality, human rights, health and safety issues":
        ["text", ""],
      "c. The SM System includes consideration of risk and crisis management": [
        "text",
        "",
      ],
      "d. Documentary evidence shows implementation of the SM system": [
        "text",
        "",
      ],
      "e. The SM System includes a process for monitoring continuous improvement in sustainability performance":
        ["text", ""],
    },
    "A2 Legal compliance": {
      comments: "",
      attachments: [],
      "a. An up to date list of all applicable legal requirements is maintained":
        ["text", ""],
      "b. Certificates or other documentary evidence show compliance with all applicable legal requirements":
        ["text", ""],
      "c. Legal requirements in all countries of operation are understood and met":
        ["text", ""],
    },
    "A3 Reporting and communication": {
      comments: "",
      attachments: [],
      "a. Regular reports are made available on sustainability performance": [
        "text",
        "",
      ],
      "b. Sustainability policies and actions are reported in external and internal communication material":
        ["text", ""],
      "c. Communications contain messages inviting consumer and stakeholder support":
        ["text", ""],
    },
    "A4 Staff engagement": {
      comments: "",
      attachments: [],
      "a. Evidence is available of staff involvement with the SM System": [
        "text",
        "",
      ],
      "b. Records of courses and on-the-job training, with attendance levels, are available":
        ["text", ""],
      "c. Staff training and guidance materials are available in accessible format (including use of minority languages where needed)":
        ["text", ""],
      "d. Staff hold certificates and qualifications in relevant disciplines/skills":
        ["text", ""],
    },
    "A5 Customer experience": {
      comments: "",
      attachments: [],
      "a. A customer feedback system is in place, together with analysis of the results":
        ["text", ""],
      "b. Negative feedback and responses made to this are recorded": [
        "text",
        "",
      ],
      "c. There is evidence of corrective actions taken": ["text", ""],
      "d. Feedback from customers is provided to tourism businesses and destinations contracted/visited":
        ["text", ""],
    },
    "A6 Accurate promotion": {
      comments: "",
      attachments: [],
      "a. Images used in promotion are of actual experiences offered and facilities provided":
        ["text", ""],
      "b. Marketing about wildlife or cultural events does not promise sightings which cannot be guaranteed":
        ["text", ""],
      "c. Sustainability claims are based on records of past performance": [
        "text",
        "",
      ],
    },
    "A7 Buildings and infrastructure": {
      "A7.1 Compliance": {
        comments: "",
        attachments: [],
        "a. Awareness of, and compliance with, laws relating to land use and activities in the local area is demonstrated":
          ["text", ""],
        "b. All required licences and permits are up to date": ["text", ""],
        "c. Awareness of, and compliance with, non-statutory area management plans and guidance (e.g. for particular zones, design, etc.), is demonstrated":
          ["text", ""],
      },
      "A7.2 Impact and integrity": {
        comments: "",
        attachments: [],
        "a. Site selection, design and access have takenaccount of visual amenity, landscape, cultural and natural heritage":
          ["text", ""],
        "b. Site selection, design and access have taken account of the protection of biologically sensitive areas and the assimilative capacity of ecosystems":
          ["text", ""],
        "c. The integrity of archaeological, cultural heritage, and sacred sites has been preserved":
          ["text", ""],
        "d. The integrity and connectivity of natural sites and protected areas has been preserved":
          ["text", ""],
        "e. Threatened or protected species have not been displaced and impact on all wildlife habitats has been minimized and mitigated":
          ["text", ""],
        "f. Water courses/catchments/wetlands have not been altered and run-off is reduced where possible and any residue is captured or channeled and filtered":
          ["text", ""],
        "g. Risk factors (including climate change, natural phenomena, and visitor safety) have been assessed and addressed":
          ["text", ""],
        "h. Impact assessment (including cumulative impacts) has beenundertaken and documented as appropriate":
          ["text", ""],
      },
      "A7.3 Sustainable practices and materials": {
        comments: "",
        attachments: [],
        "a. Local materials, practices and crafts have been used in buildings and design where practicable and appropriate":
          ["text", ""],
        "b. Native and endemic plants obtained from sustainable sources have been used in landscaping and decoration, avoiding exotic and invasive species":
          ["text", ""],
        "c. Plants have been selected for their ability to tolerate prevailing or anticipated conditions eg drought tolerant plants":
          ["text", ""],
        "d. Sustainable design, materials and construction practices have been used in buildings, with appropriate certification where possible":
          ["text", ""],
        "e. Waste from construction is sorted and disposed of in an environmentally sound manner":
          ["text", ""],
      },
      "A7.4 Access for all": {
        comments: "",
        attachments: [],
        "a. Sites,  buildings  and  activities  are  accessible  topersons  with   physical  disabilities  and  otherspecial  needs,  as  appropriate to the nature of the operation":
          ["text", ""],
        "b. Clear and accurate information is provided onthe level of accessibility":
          ["text", ""],
        "c. Accessibility is certified or checked with relevant experts/user bodies":
          ["text", ""],
      },
    },
    "A8 Land, water, and property rights": {
      comments: "",
      attachments: [],
      "a. On sites owned and operated by the organization or over which they have direct influence/control, land ownership and tenure rights are documented":
        ["text", ""],
      "b. User and access rights for key resources, including land and water, are documented where applicable":
        ["text", ""],
      "c. There is documentary evidence of communication, consultation and engagement with local and indigenous communities":
        ["text", ""],
      "d. Evidence of free, prior and informed consent of local communities is documented, where relevant (showing noinvoluntary resettlement or land acquisition)":
        ["text", ""],
    },
    "A9 Information and interpretation": {
      comments: "",
      attachments: [],
      "a. Information/interpretation  material  about  the natural and cultural heritage of the local area is available and provided to customers":
        ["text", ""],
      "b. Staff are informed and trained about the natural and cultural heritage of the local area":
        ["text", ""],
      "c. Information is provided to customers about appropriate behaviour in the areas visited":
        ["text", ""],
    },
    "A10 Destination engagement": {
      comments: "",
      attachments: [],
      "a. The organization is in contact with the local Destination Management Organization or equivalent body in those locations where it is most active":
        ["text", ""],
      "b. The organization engages in the planning and management of sustainable tourism in those destinations where it is most active":
        ["text", ""],
    },
  },
  "Tour Operators - Section B: Maximize social and economic benefits to the local community and minimize negative impacts":
    {
      "B1 Community support": {
        comments: "",
        attachments: [],
        "a. The organization supports initiatives with local communities in areas where it is particularly active":
          ["text", ""],
        "b. The level and nature of contributions made to schemes in the local communities is recorded":
          ["text", ""],
        "c. In selecting service providers and products/experiences to feature in programmes, the organization favours those that engage with and support local communities":
          ["text", ""],
      },
      "B2 Local employment": {
        comments: "",
        attachments: [],
        "a. The organization seeks to provide employment opportunities for local residents in its operations and activities":
          ["text", ""],
        "b. The organization monitors the level and proportion of employment it provides for local residents":
          ["text", ""],
        "c. Training is offered to local residents to enhance their employment opportunities":
          ["text", ""],
        "d. In selecting service providers and products/experiences to feature in programmes, the organization favours those that that provide local employment":
          ["text", ""],
      },
      "B3 Local purchasing": {
        comments: "",
        attachments: [],
        "a. The organization regularly audits its sources of supply of goods and services":
          ["text", ""],
        "b. In selecting service providers and products/experiences to feature in programmes, the organization favours those that are locally owned and operated.":
          ["text", ""],
      },
      "B4 Local entrepreneurs": {
        comments: "",
        attachments: [],
        "a. Where appropriate, the organization provides advice and support to local service providers with whom it engages, on the quality and sustainability of their service":
          ["text", ""],
        "b. Opportunities for joint ventures and partnerships with local entrepreneurs are considered and pursued where appropriate":
          ["text", ""],
      },
      "B5 Exploitation and harassment": {
        comments: "",
        attachments: [],
        "a. The organization has a documented policy against exploitation and harassment of vulnerable groups":
          ["text", ""],
        "b. Action is taken to communicate and implement the policy": [
          "text",
          "",
        ],
        "c. The organization engages with the local community, in destinations where it is particularly active, in working against exploitation and harassment":
          ["text", ""],
        "d. Records of employee ages are kept and show absence of any form of child labour (as defined by ILO)":
          ["text", ""],
        "e. The organization supports action against child sex tourism": [
          "text",
          "",
        ],
        "f. Services providers and premises where there is any evidence of possible exploitation are not contracted or visited":
          ["text", ""],
      },
      "B6 Equal opportunity": {
        comments: "",
        attachments: [],
        "a. The organization has identified groups at risk of discrimination, including women and local minorities":
          ["text", ""],
        "b. The proportion of employees drawn from each of these groups is monitored":
          ["text", ""],
        "c. Internal promotion includes members of these groups": ["text", ""],
      },
      "B7 Decent work": {
        comments: "",
        attachments: [],
        "a. The organization demonstrates awareness of, and compliance with, international labour standards and regulations":
          ["text", ""],
        "b. Wage levels are monitored and regularly reviewed against national norms for a living wage in the countries of employment":
          ["text", ""],
        "c. Training records are kept for all staff, showing the level and frequency of training received":
          ["text", ""],
        "d. Employee contracts show support for health care and social security":
          ["text", ""],
        "e. Water, sanitation and hygiene facilities are provided for all onsite workers":
          ["text", ""],
        "f. Employee satisfaction is monitored": ["text", ""],
        "g. An employee grievance mechanism is in place": ["text", ""],
      },
      "B8 Community services": {
        comments: "",
        attachments: [],
        "a. The organization monitors its impact on the availability of local services in the main areas of operation/visited":
          ["text", ""],
        "b. A communication/feedback/grievance mechanism is in place for local communities  in the main areas of operation/visited":
          ["text", ""],
        "c. Any reduction in availability of basic services to local communities, identified as the result of the organization’s activities, is addressed":
          ["text", ""],
      },
      "B9 Local livelihoods": {
        comments: "",
        attachments: [],
        "a. Local access to livelihoods is considered in decisions about development and operations":
          ["text", ""],
        "b. A communication mechanism is in place for local communities to report any instance of reduced access to local livelihoods  in the main areas of operation/visited":
          ["text", ""],
      },
    },
  "Tour Operators - Section C: Maximize benefits to cultural heritage and minimize negative impacts":
    {
      "C1 Cultural interactions": {
        comments: "",
        attachments: [],
        "a. The organization demonstrates awareness of, and compliance with, existing international, national and local good practice and guidance for tourist visits to cultural sitesand indigenous communities":
          ["text", ""],
        "b. The organization engages with communities/sites in reviewing guidance and creating and agreeing additional guidelines as necessary":
          ["text", ""],
        "c. Guidelines are effectively used and communicated": ["text", ""],
        "d. Particular measures are in place to avoid inappropriate interaction with children":
          ["text", ""],
        "e. The organization participates in/supports training and use of local guides":
          ["text", ""],
        "f. Consideration is given to the capacity and fragility of sites and communities, and to the levels of pressure on them, in determining the size, frequency and timing of group visits":
          ["text", ""],
        "g. Feedback from local communities and from visitors is encouraged and acted upon":
          ["text", ""],
      },
      "C2 Protecting cultural heritage": {
        comments: "",
        attachments: [],
        "a. The organization makes and records monetary contributions to the protection of cultural heritagein its main areas of operation/visited.":
          ["text", ""],
        "b. The organization provides in-kind or other support for cultural heritage in its main areas of operation/visited.":
          ["text", ""],
        "c. The organization ensures that its activities do not impede local access to sites":
          ["text", ""],
      },
      "C3 Presenting culture and heritage": {
        comments: "",
        attachments: [],
        "a. Sites visited and experiences offered provide an authentic experience of local culture and heritage":
          ["text", ""],
        "b. Living cultural heritage and traditions are evident in cuisine, retail, events and other services offered":
          ["text", ""],
        "c. Copyright and intellectual property rights have been observed and necessary permissions obtained":
          ["text", ""],
        "d. The views of the local community have been sought on the presentation of local cultural heritage":
          ["text", ""],
      },
      "C4 Artefacts": {
        comments: "",
        attachments: [],
        "a. Any use of artefacts is transparent and/or documented and reported":
          ["text", ""],
        "b. Where artefacts are used, laws and by laws have been identified that permit such use":
          ["text", ""],
        "c. Visitors are prevented from removing or damaging artefacts": [
          "text",
          "",
        ],
      },
    },
  "Tour Operators - Section D: Maximize benefits to the environment and minimize negative impacts":
    {
      "D1 Conserving resources": {
        "D1.1 Environmentally preferable purchasing": {
          comments: "",
          attachments: [],
          "a. A documented environmental purchasing policy is in place": [
            "text",
            "",
          ],
          "b. Preference is given to products and suppliers with environmental certification – notably with respect to wood, paper, fish, other foods, and products from the wild":
            ["text", ""],
          "c. Where certified products and suppliers are not available, consideration is given to origin and methods of growing or production":
            ["text", ""],
          "d. Threatened species are not used or sold": ["text", ""],
          "e. Service providers and other operators selected and featured in tours have environmental/sustainability certification where possible":
            ["text", ""],
          "f. Where certified businesses are not available, the sustainability performance of service providers is considered and required improvements are communicated and implemented":
            ["text", ""],
        },
        "D1.2 Efficient purchasing": {
          comments: "",
          attachments: [],
          "a. Purchasing favours reusable, returnable and recycled goods": [
            "text",
            "",
          ],
          "b. Purchasing and use of consumable and disposable goods are monitored and managed":
            ["text", ""],
          "c. Unnecessary packaging (especially from food) is avoided, with buying in bulk as appropriate":
            ["text", ""],
        },
        "D1.3 Energy conservation": {
          comments: "",
          attachments: [],
          "a. Energy used in the organization’s operations and those over which it has direct influence/control is monitored and managed.":
            ["text", ""],
          "b. Renewable sources are favoured and the share of renewable energy in total energy supply is monitored and managed":
            ["text", ""],
          "c. Equipment and practices are used that minimize energy use": [
            "text",
            "",
          ],
          "d. Goals for reducing energy consumption are in place": ["text", ""],
          "e. Staff and guests are given guidance on minimizing energyuse": [
            "text",
            "",
          ],
        },
        "D1.4 Water conservation": {
          comments: "",
          attachments: [],
          "a. Water risk in the main destinations visited has been assessed and documented":
            ["text", ""],
          "b. In destinations visited where water risk has been assessed as high, water stewardship goals have been determined":
            ["text", ""],
          "c. Water used in the organization’s operations and those over which it has direct influence/control is monitored and managed":
            ["text", ""],
          "d. Equipment and practices are used that minimize water consumption":
            ["text", ""],
          "e. Water originates from a legal and sustainable source which has not previously affected, and is unlikely in future to affect, environmental flows":
            ["text", ""],
          "f. Consideration is given to cumulative impacts of tourist in the locality on water sources":
            ["text", ""],
          "g. Goals for reducing water consumption are in place. Staff and guests are given guidance on minimizing water use":
            ["text", ""],
        },
      },
      "D2 Reducing pollution": {
        "D2.1 Greenhouse gas emissions": {
          comments: "",
          attachments: [],
          "a. Total direct and indirect greenhouse gas emissions from the organization’s operations and those over which it has direct influence/control are monitored and managed":
            ["text", ""],
          "b. Carbon Footprint per tourist/night is monitored and managed": [
            "text",
            "",
          ],
          "c. Actions are taken to avoid and reduce significant annual emissions from all sources controlled by the organization":
            ["text", ""],
          "d. Actions are taken to encourage suppliers of products and services to avoid and reduce significant annual emissions":
            ["text", ""],
          "e. Carbon offset mechanisms are used where practical": ["text", ""],
        },
        "D2.2 Transport": {
          comments: "",
          attachments: [],
          "a. Where practical and feasible, the cleanest and most resource efficient transport options are used in the provision of tour programmes and excursions":
            ["text", ""],
          "b. Information is provided and promoted to customers on alternative (climate friendly) transport options, where available":
            ["text", ""],
          "c. Alternative transport options (e.g. bike rental, car sharing, pick-ups) for guests and staff are provided or facilitated":
            ["text", ""],
          "d. Markets accessible by short and more sustainable transport options are favoured":
            ["text", ""],
          "e. Local suppliers are favoured and daily operations seek to minimize transport use":
            ["text", ""],
        },
        "D2.3 Wastewater": {
          comments: "",
          attachments: [],
          "a. The organization is aware of wastewater treatment arrangements in the main destinations visited, and seeks to influence their improvement where necessary and practicable":
            ["text", ""],
          "b. Wastewater resulting from organization’s operations and those over which it has direct influence/control is disposed of to a municipal or government approved treatment system, if available":
            ["text", ""],
          "c. If suitable municipal wastewater treatment is not available,there is a system in place on site to treat wastewater (that meets international wastewater quality requirements) and ensures no adverse effects on the local population and the environment":
            ["text", ""],
        },
        "D2.4 Solid waste": {
          comments: "",
          attachments: [],
          "a. The organization is aware of waste management arrangements in the main destinations visited, and seeks to influence their improvement where necessary and practicable":
            ["text", ""],
          "b. A solid waste management plan is in place for the organization’s operations and those over which it has direct influence/control.":
            ["text", ""],
          "c. The solid waste management plan includes actions to reduce, separate and reuse or recycle food waste where applicable":
            ["text", ""],
          "d. Waste disposal is to a government run or approved facility and there is evidence that the facility has no negative impact on the environment or local population":
            ["text", ""],
          "e. Solid waste disposed is measured by type and goals are inplace to minimize non-diverted solid waste":
            ["text", ""],
          "f. Guidance is given to customers, staff and suppliers of products and services on minimizing waste":
            ["text", ""],
        },
        "D2.5 Harmful Substances": {
          comments: "",
          attachments: [],
          "a. An inventory of hazardous waste has been made and material safety data sheets (MSDS) are held":
            ["text", ""],
          "b. Action has been taken to source more environmentally friendly alternatives":
            ["text", ""],
          "c. Chemicals, especially those in bulk amounts, are stored and handled in accordance with appropriate standards":
            ["text", ""],
          "d. Visitors are informed in advance to avoid use of personal toiletries and other substances which may be considered harmful to the local environment":
            ["text", ""],
        },
        "D2.6 Minimize pollution": {
          comments: "",
          attachments: [],
          "a. The potential sources of pollution covered in the criterion have been reviewed and identified":
            ["text", ""],
          "b. The potential sources of pollution covered in the criterion are monitored":
            ["text", ""],
          "c. Action is taken to minimize and where possible eliminate pollution from the sources covered in the criterion":
            ["text", ""],
        },
      },
      "D3 Conserving biodiversity, ecosystems and landscapes": {
        "D3.1 Biodiversity conservation": {
          comments: "",
          attachments: [],
          "a. The organization demonstrates awareness of natural protected areas and areas of high biodiversity value in the areas visited":
            ["text", ""],
          "b. The organization provides and records monetary support for biodiversity conservation in its main areas of operation/visited":
            ["text", ""],
          "c. The organization provides and records in-kind or other support for biodiversity conservation in its main areas of operation/visited":
            ["text", ""],
          "d. Properties owned or operated by the organization and those over which it has direct influence/control are actively managed to support biodiversity conservation":
            ["text", ""],
          "e. The organization is aware of, and mitigates, activity with potential to disturb wildlife and habitats":
            ["text", ""],
          "f. Compensation is made where any disturbance has occurred": [
            "text",
            "",
          ],
          "g. Action is taken to encourage visitors to support biodiversity conservation":
            ["text", ""],
          "h. The organization engages with local conservation NGOs in its main areas of operation/visited":
            ["text", ""],
        },
        "D3.2 Invasive species": {
          comments: "",
          attachments: [],
          "a. Properties owned or operated by the organization and those over which it has direct influence/control are monitored for presence of any invasive species":
            ["text", ""],
          "b. Action is taken to ensure invasive species are not introduced or spread":
            ["text", ""],
          "c. A programme is in place to eradicate and control invasive species":
            ["text", ""],
          "d. Landscaping of sites is reviewed to consider use of native species":
            ["text", ""],
        },
        "D3.3 Visits to natural sites": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, existing guidelines for tourist visits to natural sites":
            ["text", ""],
          "b. Guidelines are used when conducting visits and informing guests":
            ["text", ""],
          "c. The organization engages with local conservation bodies to establish/identify issues concerning visits to particular sites":
            ["text", ""],
          "d. The organization participates in/supports training and use of local guides in natural sites":
            ["text", ""],
          "e. Consideration is given to the capacity and fragility of natural sites, and to the levels of pressure on them, in determining the size, frequency and timing of group visits":
            ["text", ""],
          "f. Feedback from local communities and from visitors is encouraged and acted upon":
            ["text", ""],
        },
        "D3.4 Wildlife interactions": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, existing local, national and international regulations and guidelines concerning wildlife interactions, including wildlife viewing":
            ["text", ""],
          "b. The organization engages with the development and implementation of local codes and guidelines for wildlife interactions, including wildlife viewing, as required, based on advice of wildlife experts":
            ["text", ""],
          "c. The organization ensures that all service providers and sites visited comply with existing local, national and international regulations and guidelines concerning wildlife interactions, including wildlife viewing":
            ["text", ""],
          "d. Direct interactions, in particular feeding, should not be permitted, unless specifically sanctioned by internationally accepted standards or, where standards are not   available, guided by independent wildlife expert advice":
            ["text", ""],
          "e. Measures are taken to minimize disturbance to wildlife": [
            "text",
            "",
          ],
          "f. Impacts on wildlife wellbeing are regularly monitored and addressed":
            ["text", ""],
        },
        "D3.5 Animal welfare": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, relevant laws and regulations concerning captive wildlife":
            ["text", ""],
          "b. Existing guidelines for specific tourist activities involving captive wildlife are implemented":
            ["text", ""],
          "c. Personnel responsible for captive wildlife have appropriate qualifications and experience and are fully licensed":
            ["text", ""],
          "d. The organization is aware of, and complies with, relevant laws and regulations concerning animal welfare":
            ["text", ""],
          "e. The organization ensures that all service providers and sites visited comply with relevant laws, regulations and guidelines concerning captive wildlife and animal welfare":
            ["text", ""],
          "f. There is regular inspection of conditions of captive wildlife and their housing":
            ["text", ""],
          "g. There is regular inspection of conditions of domestic animals and their housing and handling":
            ["text", ""],
        },
        "D3.6 Wildlife harvesting and trade": {
          comments: "",
          attachments: [],
          "a. The organization is aware of, and complies with, relevant laws and regulations concerning wildlife harvesting and trade":
            ["text", ""],
          "b. The organization ensures that all service providers and sites visited comply with relevant laws and regulations concerning wildlife harvesting and trade":
            ["text", ""],
          "c. Visitors are informed of regulations concerning wildlife harvesting, consumption and trade and of the need to avoid buying illegal products/souvenirs derived from threatened species of wildlife notified by IUCN or CITES":
            ["text", ""],
          "d. Where hunting activity is legal, it forms part of a scientifically based, properly managed and strictly enforcedapproach to conservation":
            ["text", ""],
        },
      },
    },
  // }
  // "Destinations" : {
  "Destinations - Section A: Sustainable management": {
    "A(a) Management structure and framework": {
      "A1 Destination management responsibility": {
        comments: "",
        attachments: [],
        "a. Documentary evidence showing relevant make-up and responsibilities of the group":
          ["text", ""],
        "b. A financial plan and budget showing current and future funding sources":
          ["text", ""],
        "c. Evidence of links and engagement with other bodies": ["text", ""],
        "d. Records of permanent staff and contracted personnel, indicating relevant experience":
          ["text", ""],
        "e. Management guidelines and processes, which demonstrate awareness and adherence to sustainability principles and transparency in operations and letting of contracts":
          ["text", ""],
      },
      "A2 Destination management strategy and action plan": {
        comments: "",
        attachments: [],
        "a. A published document setting out the current destination strategy and action":
          ["text", ""],
        "b. The strategy/plan clearly visible and available online": [
          "text",
          "",
        ],
        "c. Evidence of stakeholder consultation, meetings, etc. in developing the plan":
          ["text", ""],
        "d. Reference to sustainability principles and an assessment of assets, issues, and risks, contained in the strategy and action plan":
          ["text", ""],
        "e. Specific references in the strategy/action plan to wider sustainable development policy (including pursuit of the SDGs), and vice versa":
          ["text", ""],
      },
      "A3 Monitoring and reporting": {
        comments: "",
        attachments: [],
        "a. Specific quantifiable socio-economic, cultural and environmental indicators and targets identified":
          ["text", ""],
        "b. Measurement against these indicators, with results recorded and publicised at least annually":
          ["text", ""],
        "c. Written evidence of monitoring and reporting of actions and outcomes":
          ["text", ""],
        "d. Previous reviews of monitoring system and schedule for future reviews":
          ["text", ""],
      },
    },
    "A(b) Stakeholder engagement": {
      "A4  Enterprise engagement and sustainability standards": {
        comments: "",
        attachments: [],
        "a. Evidence of regular communication of sustainability issues to tourism-related businesses (Media, meetings, direct contact, etc.)":
          ["text", ""],
        "b. Sustainability support and advice to tourism-related businesses – available and promoted":
          ["text", ""],
        "c. Number and percentage of businesses certified against tourism sustainability standards (and whether GSTC recognized/accredited), with targets for wider outreach":
          ["text", ""],
        "d. Evidence of promotion of certification schemes": ["text", ""],
        "e. List of tourism-related certified enterprises, kept up to date": [
          "text",
          "",
        ],
      },
      "A5 Resident engagement and feedback": {
        comments: "",
        attachments: [],
        "a. Evidence of the promotion and facilitation of public participation in destination planning/management":
          ["text", ""],
        "b. Information on the type and level of such participation": [
          "text",
          "",
        ],
        "c. Surveys of residents and other systematic feedback mechanisms, covering tourism issues":
          ["text", ""],
        "d. Evidence of action taken in response to residents’ feedback": [
          "text",
          "",
        ],
        "e. Programme of information, education and training on tourism provided for residents":
          ["text", ""],
      },
      "A6 Visitor engagement and feedback": {
        comments: "",
        attachments: [],
        "a. Visitor surveys (and other feedback mechanisms) – carried out and reported":
          ["text", ""],
        "b. Surveys and feedback include visitor reaction to sustainability issues":
          ["text", ""],
        "c. Evidence of actions taken in response to visitor survey/feedback findings":
          ["text", ""],
        "d. Examples of visitor information that covers sustainability issues and how to respond to them":
          ["text", ""],
      },
      "A7 Promotion and information": {
        comments: "",
        attachments: [],
        "a. Current information and promotional material with appropriate content":
          ["text", ""],
        "b. A process exists for checking the accuracy and appropriateness of destination promotion and information":
          ["text", ""],
        "c. Evidence of consultation with local communities and environmental and cultural bodies on communications content and delivery":
          ["text", ""],
      },
    },
    "A(c) Managing pressure and change": {
      "A8 Managing visitor volumes and activities": {
        comments: "",
        attachments: [],
        "a. The destination management strategy and action plan addresses seasonality and spread of visitation":
          ["text", ""],
        "b. Variation in visitor volumes throughout the year is monitored, including in the most visited locations":
          ["text", ""],
        "c. Impacts of visitor volumes and activities are identified through observation and community and stakeholder feedback":
          ["text", ""],
        "d. Actions taken to manage visitor flows and impacts": ["text", ""],
        "e. Marketing strategy and selection of target markets takes account of visit patterns, the impact of activities and destination needs":
          ["text", ""],
      },
      "A9 Planning regulations and development control": {
        comments: "",
        attachments: [],
        "a. Specific policies/regulations/guidelines which control development – documented and identified by title and date":
          ["text", ""],
        "b. Impact assessment requirements are set out, covering environmental, economic, and socio-cultural impacts, at sufficient scale to address long-term issues for the destination":
          ["text", ""],
        "c. Specific regulations on property rental and operation for tourism, with evidence of their application and enforcement":
          ["text", ""],
        "d. Evidence of public participation in the development of policies/regulations/guidelines":
          ["text", ""],
        "e. Evidence of consultation with, and consent from, indigenous people or minority ethnic groups when tourism development has been proposed or has occurred in their territories":
          ["text", ""],
        "f. Evidence of communication and enforcement of the policies/regulations/guidelines, at planning, development and implementation stages":
          ["text", ""],
      },
      "A10  Climate change adaptation": {
        comments: "",
        attachments: [],
        "a. The destination management strategy and action plan identifies and addresses climate issues":
          ["text", ""],
        "b. Regulations, guidelines and zoning for tourism development and activities accommodate the consequences of climate change":
          ["text", ""],
        "c. A climate risk assessment, covering current and future risks – undertaken and made publicly available":
          ["text", ""],
        "d. Evidence of consideration of impact on, and contribution of, local ecosystems to climate change adaptation":
          ["text", ""],
        "e. Information on climate change that has been made publicly available":
          ["text", ""],
      },
      "A11  Risk and crisis management": {
        comments: "",
        attachments: [],
        "a. A documented risk reduction, crisis management, and emergency response plan for tourism in the destination":
          ["text", ""],
        "b. The plan recognizes a wide range of risks, including natural disasters, terrorism, health, resource depletion, and others appropriate to the location":
          ["text", ""],
        "c. Communication procedures identified for use during and after an emergency":
          ["text", ""],
        "d. Programme for local delivery of information and training on risk and crisis management":
          ["text", ""],
      },
    },
  },
  "Destinations - Section B: Socio-economic sustainability": {
    "B(a) Delivering local economic benefits": {
      "B1  Measuring the economic contribution of tourism": {
        comments: "",
        attachments: [],
        "a. Programme of economic data gathering": ["text", ""],
        "b. Annual reports on the direct and indirect economic contribution of tourism in the destination":
          ["text", ""],
        "c. Data covering a range of measures of economic impact (e.g. volume, expenditure, employment, investment, and spread of economic benefit in the destination)":
          ["text", ""],
      },
      "B2 Decent work and career opportunities": {
        comments: "",
        attachments: [],
        "a. Provision of relevant skills training programmes/courses, available locally":
          ["text", ""],
        "b. Statements of commitment by tourism enterprises to the provision of decent work/career opportunities":
          ["text", ""],
        "c. Training and employment opportunities promoted to and taken up by local people, including women, young people, minorities, and people with disabilities":
          ["text", ""],
        "d. Channels for checking working conditions and receiving/handling grievances (e.g. involvement of labour unions)":
          ["text", ""],
      },
      "B3 Supporting local entrepreneurs and fair trade": {
        comments: "",
        attachments: [],
        "a. Advice, finance, or other support – available in the destination for tourism-related SMEs":
          ["text", ""],
        "b. Assistance with market access for local tourism-related SMEs": [
          "text",
          "",
        ],
        "c. Action to encourage and assist local tourism enterprises to purchase goods and services locally":
          ["text", ""],
        "d. Initiatives to help local farmers, artisans, and food producers to engage in the tourism value chain":
          ["text", ""],
        "e. Local produce and crafts identified, promoted, and available for sale to visitors in the destination":
          ["text", ""],
      },
    },
    "B(b) Social wellbeing and impacts": {
      "B4 Support for community": {
        comments: "",
        attachments: [],
        "a. Programme of economic data gathering": ["text", ""],
        "b. Annual reports on the direct and indirect economic contribution of tourism in the destination":
          ["text", ""],
        "c. Data covering a range of measures of economic impact (e.g. volume, expenditure, employment, investment, and spread of economic benefit in the destination)":
          ["text", ""],
      },
      "B5 Preventing exploitation and discrimination": {
        comments: "",
        attachments: [],
        "a. Provision of relevant skills training programmes/courses, available locally":
          ["text", ""],
        "b. Statements of commitment by tourism enterprises to the provision of decent work/career opportunities":
          ["text", ""],
        "c. Training and employment opportunities promoted to and taken up by local people, including women, young people, minorities, and people with disabilities":
          ["text", ""],
        "d. Channels for checking working conditions and receiving/handling grievances (e.g. involvement of labour unions)":
          ["text", ""],
      },
      "B6 Property and user rights": {
        comments: "",
        attachments: [],
        "a. Reference (title, date) to specific laws that pertain in the destination regarding property rights and acquisitions and user and access rights to resources":
          ["text", ""],
        "b. Reference in the above laws to communal and indigenous rights, public consultation and resettlement":
          ["text", ""],
        "c. Evidence of enforcement of the above laws in the context of tourism development and activity":
          ["text", ""],
        "d. Evidence of community consultation, consent and compensation": [
          "text",
          "",
        ],
      },
      "B7 Safety and security": {
        comments: "",
        attachments: [],
        "a. Security and health services are well established and active in the destination":
          ["text", ""],
        "b. The needs of visitors are identified and addressed in the delivery of security and health services":
          ["text", ""],
        "c. Tourism facilities are inspected for compliance with safety and hygiene standards":
          ["text", ""],
      },
      "B8 Access for all": {
        comments: "",
        attachments: [],
        "a. The existence of any regulations and standards regarding the accessibility of visitor sites, facilities and services":
          ["text", ""],
        "b. Consistent application of accessibility standards in public facilities":
          ["text", ""],
        "c. Data on the extent/proportion of visitor sites and facilities that are accessible":
          ["text", ""],
        "d. Evidence of programmes to improve access for people with a range of access needs":
          ["text", ""],
        "e. Information on accessibility included in communications about the destination as a whole":
          ["text", ""],
        "f. Details of accessibility included in visitor information about key sites":
          ["text", ""],
      },
      "B9 Local livelihoods": {
        comments: "",
        attachments: [],
        "a. Local access to livelihoods is considered in decisions about development and operations":
          ["text", ""],
        "b. A communication mechanism is in place for local communities to report any instance of reduced access to local livelihoods":
          ["text", ""],
      },
    },
  },
  "Destinations - Section C: Cultural sustainability": {
    "C(a) Protecting cultural heritage": {
      "C1 Protection of cultural assets": {
        comments: "",
        attachments: [],
        "a. Lists of cultural assets, including evaluation and indication of vulnerability":
          ["text", ""],
        "b. Programme of rehabilitation and conservation of assets": [
          "text",
          "",
        ],
        "c. Mechanisms for using income from tourism to support conservation of cultural assets":
          ["text", ""],
      },
      "C2 Cultural artefacts": {
        comments: "",
        attachments: [],
        "a. Reference to relevant laws relating to historical artefacts pertaining in the destination (title, date)":
          ["text", ""],
        "b. Evidence of communication of relevant laws to tourism enterprises and visitors":
          ["text", ""],
        "c. Evidence of enforcement of relevant laws": ["text", ""],
      },
      "C3  Intangible heritage": {
        comments: "",
        attachments: [],
        "a. Identification and listing of intangible cultural heritage": [
          "text",
          "",
        ],
        "b. Examples of celebration and visitor experiences of intangible cultural heritage (events, distinctive products etc.)":
          ["text", ""],
        "c. Evidence of involvement of local and indigenous communities in developing and delivering visitor experiences based on intangible cultural heritage":
          ["text", ""],
        "d. Feedback from visitors and local communities on delivery of intangible heritage experiences":
          ["text", ""],
      },
      "C4 Traditional access": {
        comments: "",
        attachments: [],
        "a. Monitoring of accessibility to natural and cultural sites for the local community":
          ["text", ""],
        "b. Evidence of engagement with the local community regarding traditional access":
          ["text", ""],
        "c. Specific action to protect and/or rehabilitate local community access":
          ["text", ""],
      },
      "C5 Intellectual property": {
        comments: "",
        attachments: [],
        "a. Reference to laws on intellectual property pertaining in the destination (title, date)":
          ["text", ""],
        "b. Communication of intellectual property rights to tourism stakeholders":
          ["text", ""],
        "c. Evidence that intellectual property rights are protected in the development of cultural experiences for visitors":
          ["text", ""],
      },
    },
    "C(b) Visiting cultural sites": {
      "C6 Visitor management at cultural sites": {
        comments: "",
        attachments: [],
        "a. Monitoring of visitor flows and impact on cultural sites, with results shared across the destination":
          ["text", ""],
        "b. Evidence of action to manage tourism-related impacts in or around cultural sites":
          ["text", ""],
        "c. Existence and distribution of published guidelines on visitor behaviour at sensitive sites and cultural events and periodic monitoring of compliance":
          ["text", ""],
        "d. A code of practice for tour operators and tour guides and/or other engagement with them on visitor management at cultural sites":
          ["text", ""],
        "e. Provision of training for guides": ["text", ""],
      },
      "C7 Site interpretation": {
        comments: "",
        attachments: [],
        "a. Provision of informative interpretative material onsite and in formats that are accessible pre-arrival":
          ["text", ""],
        "b. Evidence that interpretative material has been well researched and is accurate":
          ["text", ""],
        "c. Interpretation material that identifies the significance and sensitivity/fragility of sites":
          ["text", ""],
        "d. Evidence of host community collaboration in preparation of relevant interpretative material":
          ["text", ""],
        "e. Interpretative material available in relevant languages": [
          "text",
          "",
        ],
      },
    },
  },
  "Destinations - Section D:  Environmental sustainability": {
    "D(a) Conservation of natural heritage": {
      "D1 Protection of sensitive environments": {
        comments: "",
        attachments: [],
        "a. List of natural heritage sites and assets, indicating type, conservation status and vulnerability":
          ["text", ""],
        "b. Programmes to conserve biodiversity and natural heritage": [
          "text",
          "",
        ],
        "c. Programmes to eradicate and control invasive species": ["text", ""],
        "d. Action to identify, monitor and mitigate tourism impacts on biodiversity and natural heritage":
          ["text", ""],
        "e. Mechanisms for using income from tourism to support conservation of natural assets":
          ["text", ""],
        "f. Communications with visitors and enterprises on reducing spread of alien species":
          ["text", ""],
      },
      "D2 Visitor management at natural sites": {
        comments: "",
        attachments: [],
        "a. Monitoring of visitor flows and impact on natural sites, with results shared across the destination":
          ["text", ""],
        "b. Evidence of action to manage and mitigate tourism-related impacts in or around natural sites":
          ["text", ""],
        "c. Existence and distribution of published guidelines on visitor behaviour at sensitive sites, and periodic monitoring of compliance":
          ["text", ""],
        "d. A code of practice for tour operators and tour guides and/or other engagement with them on visitor management at natural sites":
          ["text", ""],
        "e. Cooperation with local conservation bodies to identify environmental risks associated with tourism and measures to reduce them":
          ["text", ""],
        "f. Provision of training for guides": ["text", ""],
      },
      "D3 Wildlife interaction": {
        comments: "",
        attachments: [],
        "a. Reference (title, date) to international, national and local laws that apply in the destination regarding interaction with wildlife":
          ["text", ""],
        "b. Endorsement of international standards for wildlife viewing for both marine and terrestrial species":
          ["text", ""],
        "c. Distribution of a code of practice for wildlife interaction, including viewing, which reflects international standards":
          ["text", ""],
        "d. System for checking compliance with regulations, and code of practice amongst tourism operations":
          ["text", ""],
        "e. Actions to monitor wildlife wellbeing and minimize disturbance, in locations where interactions occur":
          ["text", ""],
        "f. Provision of information to visitors on harmful wildlife interaction, such as touching and feeding":
          ["text", ""],
      },
      "D4 Species exploitation and animal welfare": {
        comments: "",
        attachments: [],
        "a. Reference (title, date) to specific international, national and local laws, standards and guidelines that apply in the destination regarding animal welfare and conservation of species":
          ["text", ""],
        "b. Notification of laws, standards and guidelines to tourism enterprises and guides":
          ["text", ""],
        "c. A system for inspection of the conditions of captive wildlife and domestic animals, including their housing and handling":
          ["text", ""],
        "d. Licensing and checking of qualifications of personnel responsible for captive wildlife":
          ["text", ""],
        "e. Action to promote the Convention on International Trade in Endangered Species (CITES) in the tourism sector and to ensure compliance with it":
          ["text", ""],
        "f. Provision of information to visitors on avoiding trade in endangered species, e.g. in purchase of souvenirs derived from threatened species of wildlife notified by IUCN or CITES":
          ["text", ""],
        "g. Enforcement of legislation to ensure that any hunting activity is part of a scientifically based, properly managed and strictly enforced approach to conservation":
          ["text", ""],
      },
    },
    "D(b) Resource management": {
      "D5 Energy conservation": {
        comments: "",
        attachments: [],
        "a. Energy consumption targets are publicised and promoted": [
          "text",
          "",
        ],
        "b. Programme to increase energy efficiency – e.g. promoting and supporting insulation":
          ["text", ""],
        "c. Investment in renewable energy and percent of total provision/consumption":
          ["text", ""],
        "d. Support and incentives for energy monitoring and reduction by enterprises":
          ["text", ""],
      },
      "D6 Water stewardship": {
        comments: "",
        attachments: [],
        "a. Provision of guidance and support for monitoring and reduction of water usage by enterprises":
          ["text", ""],
        "b. Program to regularly assess water risk": ["text", ""],
        "c. Setting, publication and enforcement of water stewardship goals, where water risk has been assessed as high":
          ["text", ""],
        "d. Monitoring and control of sources and volume of water used for tourism purposes and its effect on local communities and ecosystems. Promotion and checking of adherence to goals by tourism enterprises":
          ["text", ""],
        "e. Visitor information on water risk and minimising water use": [
          "text",
          "",
        ],
      },
      "D7 Water quality": {
        comments: "",
        attachments: [],
        "a. Programme of water quality monitoring": ["text", ""],
        "b. Existence of data and reports on water quality": ["text", ""],
        "c. Monitoring bathing water, with certification and identification of sites reaching set standards":
          ["text", ""],
        "d. Evidence of actions to improve water quality": ["text", ""],
        "e. Information for visitors on quality of local drinking water, to encourage use as alternative to bottled water":
          ["text", ""],
      },
    },
    "D(c) Management of waste and emissions": {
      "D8 Waste Water": {
        comments: "",
        attachments: [],
        "a. Written guidelines and regulations on wastewater treatment": [
          "text",
          "",
        ],
        "b. System of enforcing guidelines amongst enterprises": ["text", ""],
        "c. Monitoring/testing of released wastewater": ["text", ""],
        "d. Provision of sustainable municipal water treatment systems, for use by the tourism sector, where practical and appropriate":
          ["text", ""],
      },
      "D9 Solid Water": {
        comments: "",
        attachments: [],
        "a. Waste monitoring programme, with results and targets published": [
          "text",
          "",
        ],
        "b. Coordinated campaign/advice/support with tourism enterprises on waste management, including food waste":
          ["text", ""],
        "c. Campaign to reduce/eliminate single use items, especially plastics":
          ["text", ""],
        "d. Waste management programme for public offices and facilities": [
          "text",
          "",
        ],
        "e. Provision of a collection and recycling system, with at least four streams (i.e. organic, paper, metal, glass and plastic)":
          ["text", ""],
        "f. Provision of sustainable system for disposal of residual waste": [
          "text",
          "",
        ],
        "g. Campaign to eliminate dropping of litter, including by visitors, and to keep public spaces clean":
          ["text", ""],
        "h. Adequate bins for separated waste disposal": ["text", ""],
      },
      "D10 GHG emissions and climate change mitigation": {
        comments: "",
        attachments: [],
        "a. Published target for percentage of emissions reduction by specified date":
          ["text", ""],
        "b. Annual climate report, including monitoring and mitigation actions":
          ["text", ""],
        "c. Supported campaign or other engagement with tourism enterprises on reduction and mitigation of emissions":
          ["text", ""],
        "d. Action to reduce emissions from public sector operations": [
          "text",
          "",
        ],
        "e. Information for enterprises and visitors on offsetting schemes that meet recognised standards":
          ["text", ""],
      },
      "D11 Low-impact transportation": {
        comments: "",
        attachments: [],
        "a. Investment in more sustainable transport infrastructure, including public transport and low emissions vehicles":
          ["text", ""],
        "b. Information promoted to visitors on alternative transport options to and within the destination":
          ["text", ""],
        "c. Data on visitor use of alternative transport modes": ["text", ""],
        "d. Improvement and promotion of cycling and walking opportunities": [
          "text",
          "",
        ],
        "e. Prioritization of visitor markets accessible by short and more sustainable transport options":
          ["text", ""],
        "f. Public sector and tourism enterprises prioritize low-impact transportation in their own operations":
          ["text", ""],
      },
      "D12 Light and noise pollution": {
        comments: "",
        attachments: [],
        "a. Guidelines on light and noise pollution – produced and promoted to tourism enterprises":
          ["text", ""],
        "b. Identification and monitoring of potential sources of noise and light pollution related to tourism":
          ["text", ""],
        "c. Mechanisms to enable residents to report noise and light pollution, with follow-up action":
          ["text", ""],
      },
    },
  },
};
